var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TrailsExam',{attrs:{"data":_vm.trial.component_data,"isPractice":_vm.isPractice},on:{"examstarted":_vm.examStart,"examaction":_vm.examEvent,"examfinished":_vm.examFinish}})}
var staticRenderFns = []

export { render, staticRenderFns }